import { Spinner } from 'react-bootstrap';
import React from 'react';

import FlexRow from './flex-row';

const FlexSpinner = () => (
  <FlexRow>
    <div></div>
    <Spinner className="m-4" animation="border" role="status" />
    <div></div>
  </FlexRow>
);

export default FlexSpinner;
